import React from 'react';
import Sheet from 'react-modal-sheet';
import Button from './common/Button';

const OtpSheet = ({
	isOpen,
	onClose,
	customDetails,
	mobileNumber,
	OTP,
	time,
	isResend,
	verifySpinner,
	isVerifyDisabled,
	onOTPChange,
	onResendOtp,
	onVerifyOtp,
}) => (
	<Sheet
		snapPoints={[400]}
		disableDrag={true}
		isOpen={isOpen}
		onClose={onClose}
	>
		<Sheet.Container>
			<Sheet.Content>
				<div className="row mx-4">
					<div className="col-12">
						<p
							className="fs-16 fw-700 text-start mt-4"
							style={{
								color: customDetails?.textColor,
								fontFamily: customDetails?.fontFamily,
								textAlign: 'left',
								color: 'black',
							}}
						>
							Verify mobile number
						</p>
					</div>
					<div className="col-12">
						<p
							className="fs-16 fw-500 text-start mt-1"
							style={{
								color: customDetails?.textColor,
								fontFamily: customDetails?.fontFamily,
							}}
						>
							Please enter the OTP sent to your registered mobile number
						</p>
					</div>
					<div className="col-12">
						<input
							type="number"
							inputMode="decimal"
							aria-label="OTP"
							className="form-control mb-2"
							value={OTP}
							onChange={(e) => onOTPChange(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === 'Enter' && !isVerifyDisabled) {
									e.preventDefault();
									onVerifyOtp();
								}
							}}
							autoFocus
							style={{ height: '50px', fontFamily: customDetails?.fontFamily }}
						/>
						<div className="d-flex align-items-center">
							<button
								className="fs-14 fw-600 link-btn"
								disabled={!isResend}
								style={{
									color: isResend ? customDetails?.primaryBtnColor : 'grey',
								}}
								onClick={onResendOtp}
							>
								Didn't recieve OTP ? Try again
							</button>
							{time !== 60 ? (
								<p
									className="fs-14 fw-600  my-auto"
									style={{
										fontFamily: customDetails?.fontFamily,
										color: '#ccc',
									}}
								>
									in {time} secs
								</p>
							) : null}
						</div>
					</div>
					<div className="col-12 d-flex justify-content-center mb-4">
						<Button
							type="button"
							disabled={isVerifyDisabled}
							onClick={onVerifyOtp}
							color={customDetails?.primaryBtnColor}
							fontFamily={customDetails?.fontFamily}
							fontSize={customDetails?.fontSize}
							size="medium"
							padding="default"
							style={{
								height: customDetails?.btnHeight,
								width: customDetails?.btnWidth,
								borderRadius: customDetails?.borderRadius,
								marginTop: '1rem',
							}}
							className="float-end fs-16 fw-600 text-white mt-3"
						>
							{verifySpinner ? (
								<div
									className="snippet"
									style={{ display: 'flex', justifyContent: 'center' }}
									data-title=".dot-pulse"
								>
									<div className="stage">
										<div className="dot-pulse-btn"></div>
									</div>
								</div>
							) : (
								'VERIFY'
							)}
						</Button>
					</div>
				</div>
			</Sheet.Content>
		</Sheet.Container>
		<Sheet.Backdrop />
	</Sheet>
);

export default OtpSheet;
